import { Button, TextField } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';
import { ImageUpload } from 'components/ImageUpload';
import { Controller } from 'react-hook-form';

export function InformationForm({
  errors,
  information,
  Controller,
  control,
  logo,
  setLogo,
  onManageBanks,
  bankData,
}) {
  const renderField = (name, label, required = false, width = 'w-full') => (
    <div className={`${width} px-1 py-2`}>
      <Controller
        name={name}
        control={control}
        defaultValue={information ? _.get(information, name, '') : ''}
        rules={{ required }}
        render={({ field }) => (
          <TextField
            {...field}
            label={label}
            required={required}
            fullWidth
            size="small"
            multiline
            helperText={_.get(errors, name) && 'กรุณาใส่ข้อมูล'}
          />
        )}
      />
    </div>
  );
  const bankDataOnly = _.filter(bankData, (b) => !b.isCash) || [];

  return (
    <div className="flex flex-row flex-wrap">
      {/* ข้อมูลระบบ */}
      {renderField('name', 'ชื่อระบบ', true)}
      {renderField('description', 'คำอธิบาย', true)}
      {renderField('url', 'URL ของระบบ', false, 'w-full lg:w-1/2')}

      {/* ข้อมูลเจ้าของระบบ */}
      <div className="w-full py-4">
        <h2 className="text-lg font-bold">ข้อมูลเจ้าของระบบ</h2>
      </div>

      {renderField(
        'owner.name',
        'ชื่อบริษัท / หน่วยงาน',
        false,
        'w-full lg:w-1/2',
      )}
      {renderField('owner.branch', 'สาขา', false, 'w-full lg:w-1/2')}
      {renderField('owner.website', 'เว็บไซต์', false, 'w-full lg:w-1/2')}
      {renderField(
        'owner.telephone',
        'เบอร์โทรศัพท์',
        false,
        'w-full lg:w-1/2',
      )}
      {renderField('owner.fax', 'แฟกซ์', false, 'w-full lg:w-1/2')}
      {renderField('owner.email', 'อีเมล', false, 'w-full lg:w-1/2')}
      {renderField(
        'owner.tax',
        'เลขประจำตัวผู้เสียภาษี',
        false,
        'w-full lg:w-1/2',
      )}

      {/* ที่อยู่ */}
      <div className="w-full py-2">
        <h3 className="text-md font-semibold">ที่อยู่</h3>
      </div>

      {renderField(
        'owner.address.house_number',
        'เลขที่',
        false,
        'w-full lg:w-1/2',
      )}
      {renderField(
        'owner.address.village_number',
        'หมู่ที่',
        false,
        'w-full lg:w-1/2',
      )}
      {renderField('owner.address.road', 'ถนน', false, 'w-full lg:w-1/2')}
      {renderField(
        'owner.address.subdistrict',
        'ตำบล',
        false,
        'w-full lg:w-1/2',
      )}
      {renderField('owner.address.district', 'อำเภอ', false, 'w-full lg:w-1/2')}
      {renderField(
        'owner.address.province',
        'จังหวัด',
        false,
        'w-full lg:w-1/2',
      )}
      {renderField(
        'owner.address.postcode',
        'รหัสไปรษณีย์',
        false,
        'w-full lg:w-1/2',
      )}
      {renderField('owner.address.country', 'ประเทศ', false, 'w-full lg:w-1/2')}

      {/* ข้อมูลธนาคาร */}
      <div className="w-full py-4">
        <div className="flex justify-between items-center">
          <h2 className="text-lg font-bold">ข้อมูลธนาคาร</h2>
          <Button
            variant="contained"
            color="primary"
            onClick={onManageBanks}
            size="small"
          >
            จัดการบัญชีธนาคาร
          </Button>
        </div>

        {bankDataOnly.length > 0 ? (
          <div className="mt-4">
            <p className="text-sm text-gray-600">
              มีบัญชีธนาคาร {bankDataOnly.length} บัญชี
            </p>
            {bankDataOnly.map((account, index) => (
              <div key={index} className="bg-gray-50 p-3 mt-2 rounded">
                <p className="text-sm">
                  <strong>{account.name || 'ไม่ระบุธนาคาร'}</strong> -
                  {account.bankName || 'ไม่ระบุชื่อบัญชี'}(
                  {account.accountNumber || 'ไม่ระบุเลขบัญชี'})
                </p>
              </div>
            ))}
            {bankDataOnly.length > 5 && (
              <p className="text-sm text-gray-500 mt-2">
                และอีก {bankData.length - 5} บัญชี...
              </p>
            )}
          </div>
        ) : (
          <p className="text-sm text-gray-500 mt-2">
            ยังไม่มีข้อมูลบัญชีธนาคาร
          </p>
        )}
      </div>

      {/* โลโก้ */}
      <div className="w-full md:w-1/2">
        <h2 className="text-lg font-bold mb-2">โลโก้หลัก</h2>
        {information?.image_logo && (
          <img
            src={information.image_logo}
            width="200"
            height="20"
            alt="Logo"
            className="mb-2"
          />
        )}
        <ImageUpload
          images={logo}
          maxNumber={1}
          previewSize={400}
          setImages={setLogo}
          profile={1}
          title="โลโก้หลัก"
        />
      </div>
    </div>
  );
}

InformationForm.propTypes = {
  errors: PropTypes.object,
  information: PropTypes.object,
  Controller: PropTypes.func,
  control: PropTypes.object,
  logo: PropTypes.array,
  setLogo: PropTypes.func,
  onManageBanks: PropTypes.func.isRequired,
};

InformationForm.defaultProps = {
  information: null,
};

export default InformationForm;
